import { render } from "./Index.vue?vue&type=template&id=1f5f31bb&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1f5f31bb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f5f31bb"

export default script